<ng-container *ngIf="isLoading | async">
  <ng-container [ngSwitch]="loadingType">
    <div class="transparency vehicle-search" *ngSwitchCase="constantLoadingType.VehicleSearch">
      <img src="assets/img/ukedon_search.sw.cache.png">
    </div>
    <div class="transparency vehicle-search" *ngSwitchCase="constantLoadingType.VehicleReservation">
      <img src="assets/img/ukedon_reserve.sw.cache.png">
    </div>
  </ng-container>
</ng-container>